import React from 'react'

export default function Shelf(props) {
 const shelfBooks=props.books;
  
  return (
 		     <div className="bookshelf">
                  <h2 className="bookshelf-title">{props.title}</h2>
                  <div className="bookshelf-books">
                    <ol className="books-grid">
    {shelfBooks &&
    shelfBooks.map(
    book=><li key={book.id} >
                        <div className="book">
                          <div className="book-top">
                                 <div className="book-cover" style={{ width: 128, height: 193, backgroundImage:                                                               `url(${book.imageLinks.thumbnail}) `     
                                 }}>
							</div>
                            <div className="book-shelf-changer">
                              <select value={book.shelf} onChange={e=>props.changeBookShelf(book,e.target.value)
}>
                                <option value="move" disabled>Move to...</option>
                                <option value="currentlyReading">Currently Reading</option>
                                <option value="wantToRead">Want to Read</option>
                                <option value="read">Read</option>
                                <option value="none">None</option>
                              </select>
                            </div>
                          </div>
                          <div className="book-title">{book.title}</div>
                          <div className="book-authors">{book.author}</div>
                        </div>
                      </li>
  )}
                      
                    
                    </ol>
                  </div>
                </div>
             
  )
}


// WEBPACK FOOTER //
// ./src/components/Shelf.js